import { render, staticRenderFns } from "./CityProfile.vue?vue&type=template&id=1c25fe67&"
import script from "./CityProfile.vue?vue&type=script&lang=js&"
export * from "./CityProfile.vue?vue&type=script&lang=js&"
import style0 from "./CityProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports